import { type VariablesOf } from '@graphql-typed-document-node/core'
import { useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

const document = graphql(`
  mutation DocumentImageInfiniteScrollList_UpdateDocumentImage(
    $comment: String
    $documentImageId: ID!
    $title: String!
  ) {
    updateDocumentImage(
      comment: $comment
      documentImageId: $documentImageId
      title: $title
    ) {
      ok
    }
  }
`)
type Variables = VariablesOf<typeof document>

export const useUpdateDocumentImageMutation = (
  options: Omit<
    UseMutationOptions<void, unknown, Variables, unknown>,
    'mutationFn'
  > = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()

  return useMutation({
    mutationFn: async (variables) => {
      const result = await graphQLRequest({ document, variables })
      const ok = result.updateDocumentImage?.ok ?? false
      if (!ok) {
        throw new Error(t('update_failed_8'))
      }
    },
    ...options,
  })
}
